export const isSubstring = (string: string, substring: string) =>
    string.toLowerCase().includes(substring.toLowerCase());
